export const GET_ASSESMENT_QUESTIONS="GET_ASSESMENT_QUESTIONS"
export const GET_ASSESMENT_QUESTIONS_SUCCESS="GET_ASSESMENT_QUESTIONS_SUCCESS"
export const GET_ASSESMENT_QUESTIONS_FAILED="GET_ASSESMENT_QUESTIONS_FAILED"
export const POST_ASSESMENT_QUESTIONS="POST_ASSESMENT_QUESTIONS"
export const POST_ASSESMENT_QUESTIONS_SUCCESS="POST_ASSESMENT_QUESTIONS_SUCCESS"
export const POST_ASSESMENT_QUESTIONS_FAILED="POST_ASSESMENT_QUESTIONS_FAILED"
export const GET_ASSESMENT_SHEET_LIST="GET_ASSESMENT_SHEET_LIST"
export const GET_ASSESMENT_SHEET_LIST_SUCCESS="GET_ASSESMENT_SHEET_LIST_SUCCESS"
export const GET_ASSESMENT_SHEET_LIST_FAILED="GET_ASSESMENT_SHEET_LIST_FAILED"
export const CHANGE_THE_STATUS="CHANGE_THE_STATUS"
export const CHANGE_THE_STATUS_SUCCESS="CHANGE_THE_STATUS_SUCCESS"
export const CHANGE_THE_STATUS_FAILED="CHANGE_THE_STATUS_FAILED"
export const GET_THE_SHEET_DATA="GET_THE_SHEET_DATA"
export const GET_THE_SHEET_DATA_SUCCESS="GET_THE_SHEET_DATA_SUCCESS"
export const GET_THE_SHEET_DATA_FAILED="GET_THE_SHEET_DATA_FAILED"
export const UPDATE_THE_SHEET="UPDATE_THE_SHEET"
export const UPDATE_THE_SHEET_SUCCESS="UPDATE_THE_SHEET_SUCCESS"
export const UPDATE_THE_SHEET_FAILED="UPDATE_THE_SHEET_FAILED"
export const GET_SUGGESTION="GET_SUGGESTION"
export const GET_SUGGESTION_SUCCESS="GET_SUGGESTION_SUCCESS"
export const GET_SUGGESTION_FAILED="GET_SUGGESTION_FAILED"
